"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Footer component
 * @param {FooterPropsType} param0 The field props
 * @returns {React.Element<*>} React element
 */
var Footer = function Footer(_ref) {
  var icon = _ref.icon,
      text = _ref.text;
  return _react2.default.createElement(
    "div",
    { className: "qd__footer" },
    _react2.default.createElement(
      "div",
      { className: "qd__footer-icon" },
      icon
    ),
    _react2.default.createElement(
      "p",
      { className: "qd__footer-text" },
      text
    )
  );
};

exports.default = Footer;